import React from 'react';
import "../i18n";
import { useTranslation } from "react-i18next";
import FormControl from '@mui/material/FormControl';

export default function ShowCode(props) {
    const public_URL = process.env.PUBLIC_URL;   
    const { t, i18n } = useTranslation();    
    const [mediumFont, setMediumFont] = React.useState("MontserratMedium");
    const [boldFont, setBoldFont] = React.useState("MontserratBold"); 
    React.useEffect(() => {          
        i18n.changeLanguage(props.language);
        changeFontbyLanguage(props.language);
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps

    function changeFontbyLanguage(lan)
    {
        if (lan === "zh") {
            setMediumFont('NotoSansSCMedium');
            setBoldFont('NotoSansSCBold');
        }
         else if(lan === "kr"){
            setMediumFont('NotoSansKRMedium');
            setBoldFont('NotoSansKRBold');
        }
        else if(lan==="en"||lan==="vn"){
            setMediumFont('MontserratMedium');
            setBoldFont('MontserratBold');
        }  
    }
    return (
        <div class="div">
            <div class="div-img">
                <div class="logo-container">
                    <img
                        src={public_URL + "/images/HOIANAREWARDSLOGO.svg"}
                        class="img"
                        alt=""
                        loading="lazy"
                    />
                </div>
                
                <div class="header-welcome-section">
                    <div class={"header-welcome-text " + boldFont}>{t("Welcome1")}</div>
                    <div class={"header-welcome-text " + boldFont}>{t("Welcome2")}</div>
                </div>
            </div>

            <div>
                <FormControl sx={{ m: 1, minWidth: 60 }}>
                    <h1 class={"thanktitle " + boldFont}>{t("ThankYou")}</h1>
                </FormControl>
            </div>
            <div class="div">
                <label class={"label "+mediumFont}>{t("Thank1")}</label><br/>
                <label class={"label "+mediumFont}>{t("Thank2")}</label><br/>
                <label class={"label "+mediumFont}>{t("Thank3")}</label><br/>
            </div>
            
            <div style={{ textAlign: 'center', marginTop: '30px', marginBottom: '20px' }}>
                <button 
                    class={"home-page-button " + mediumFont}
                    onClick={() => window.location.href = public_URL}
                >
                    {t("HomePage")}
                </button>
            </div>
        </div >
    )
}